import React from "react"
import classes from "./treatment.module.css"

const Treatment = props => {
  return (
    <div className={classes.Treatment}>
      <img src={props.image} alt={props.title} />
      <div className={classes.divider}></div>
      <div className={classes.htmlText}>{props.htmlText}</div>
    </div>
  )
}

export default Treatment
